function hasExpirition(num,) {
    let rout;
    if (num === 403) {
        localStorage.removeItem('tokenA');
    }
    return rout;
}

function hasExpiritionWithLoad(num,navigate) {
    let rout;
    if (num === 403) {
        localStorage.removeItem('tokenA');
        rout = navigate("/")
        window.location.reload();
    }
    return rout;
}

export { hasExpirition,hasExpiritionWithLoad }